const config = require("config");
(function () {
  var controllerId = "pcmmodernController";

  angular
    .module("app")
    .controller(controllerId, [ "$http","UserProvider", "eventTracker",
      function pcmmodernController($http,userProvider,eventTracker) {
        var vm = this;
        vm.pcmModernSite = config.pcmModernSite;
        $http.get('../../resources/deployments.json').then(function(response) {
          const deployments = response.data.deployments;
          const lastDeployment = deployments[deployments.length - 1];
          const currentTimestamp = Date.now();
          let inputTimestamp = new Date(lastDeployment.date).getTime();
          let timeDifference;
          if (inputTimestamp > currentTimestamp) {
            const lastDeployment = deployments[deployments.length - 2];
            inputTimestamp = new Date(lastDeployment.date).getTime();
          }
          timeDifference = currentTimestamp - inputTimestamp;
          let differeces;
          if (timeDifference < 60000) { // Less than a minute
            differeces = 'a few seconds ago';
          } else if (timeDifference < 3600000) { // Less than an hour
            var minutes = Math.floor(timeDifference / 60000);
            differeces = minutes + (minutes > 1 ? ' minutes ago' : ' minute ago');
          } else if (timeDifference < 86400000) { // Less than a day
            var hours = Math.floor(timeDifference / 3600000);
            differeces = hours + (hours > 1 ? ' hours ago' : ' hour ago');
          } else if (timeDifference < 2592000000) { // Less than a month (30 days)
            var days = Math.floor(timeDifference / 86400000);
            differeces = days + (days > 1 ? ' days ago' : ' day ago');
          } else {
            var months = Math.floor(timeDifference / 2592000000);
            console.log('moths==>', months);
            if (months < 12) { // Less than a year
              differeces = months + (months > 1 ? ' months ago' : ' month ago');
            } else if (months === 12) { // Equal to one year
              differeces = 'a year ago';
            } else { // More than one year
              differeces = 'a while ago';
            }            
          }
          vm.lastDeploymentDate = differeces;
        });
        vm.newPCMWeb = function() {
          eventTracker.track("Modern Banner Link Click From Legacy");
          window.location.href = `${config.pcmModernSite}?token=${userProvider.getUser().authToken}`;
        }
      }
    ]);
})();


// WEBPACK FOOTER //
// ./app/account/pcmmodern.controller.js